export const config = {
    // baseURL: 'https://apis.odibets.com/api/v2/',
    baseURL: 'https://api.odi.site/api/v2/',
    baseURLWEB: 'https://odashapi.ridgeways.xyz/api/v3/',
    baseURLGhana: 'http://34.78.77.38/v1/',
    replayBaseURL: 'http://34.79.74.100:8080/',
    host: 'example.com',
};